import { isBefore } from 'date-fns';
import * as React from 'react';
import { queryCache } from 'react-query';
import { AuthContext } from './AuthContext';
import { removeToken } from './session';
import { RoleType } from '../../common/types/roleType';

/**
 * Do all login related actions / data access through this hook.
 *
 * This hook works alongside AuthContext which holds the relevat login info.
 * Add global login state to AuthContext, do not store it in this hook
 */

export const useAuth = () => {
  const { token } = React.useContext(AuthContext);

  const logout = () => {
    removeToken();
    queryCache.invalidateQueries();
    window.location.href = `${process.env.REACT_APP_BASE_URL}/login`;
  };

  const roles = token?.roles || [];
  return {
    isLoggedIn:
      token && token.exp
        ? isBefore(new Date(), new Date(parseInt(`${token?.exp}000`, 10)))
        : false,
    user: token,
    roles,
    logout,
    // @ts-ignore
    hasRole: (role: RoleType) => roles.includes(role),
    admin: token?.admin,
    name: token?.name,
  };
};
